let restUrl = process.env.API_ROOT;

export { restUrl }




//////////////////
// WEBPACK FOOTER
// ./url.js
// module id = 41K4
// module chunks = 26